import styled, { keyframes } from 'styled-components'
import * as Define from '../../utils/defines/defines'

export const Container = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    ${Define.media.mobile`
        position: fixed;
        inset: 0;
        width: 100vw;
        height: 100vh;
        height: 100dvh;
    `}
`
export const BtnIcon = styled.img`
    height: 16px;
    width: 16px;
`

export const AnimateOpen = keyframes`
    from{
        opacity: 0;
    }
    to{
        opacity: 1;
    }
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Centralize = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Icon = styled.img`
    height: 50px;
    width: 50px;
    animation: ${rotate} .8s linear infinite;
`

export const Modal = styled.div<{close: boolean}>`
    min-height: 100px;
    max-height: 90vh;
    width: 560px;
    max-width: 90vw;
    background: ${Define.ModalBackground};
    border: 1px solid rgba(255,255,255,0.09);
    border-radius: 20px;
    padding: 30px;
    box-sizing: border-box;
    backdrop-filter: blur(20px);
    box-shadow: 0 20px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.06);
    animation-name: ${AnimateOpen};
    animation-duration: .3s;
    animation-timing-function: ease-in;
    ${Define.media.mobile`
        position: fixed;
        inset: 0;
        width: 100vw !important;
        height: 100vh !important;
        height: 100dvh !important;
        max-width: 100vw !important;
        max-height: 100vh !important;
        max-height: 100dvh !important;
        border-radius: 0;
        padding: 20px 16px;
    `}
`

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
`

export const TitleContent = styled.div`
    display: flex;
    flex-direction: column
`

export const Title = styled.p`
    margin: 0;
    font-family: "Montserrat";
    font-size: 20px;
    color: #FFF;
    font-weight: 600;
`
export const SubTitle = styled.p`
    margin: 0;
    font-family: "Nunito";
    font-size: 18px;
    color: #FFF;
    opacity: 0.8;
`

export const Content = styled.div`
    overflow-y: scroll;
    ::-webkit-scrollbar {
        display: none;
    }
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(90vh - 110px);
    ${Define.media.mobile`
        max-height: calc(100vh - 110px);
        max-height: calc(100dvh - 110px);
    `}
`